module.exports = __webpack_public_path__ + "static/cgu-821953ad0e054bd723712bae876ee9fb.pdf";